<script lang="ts">
  type Color = "error" | "dark";
  export let size = 16;
  export let color: Color = "error";
</script>

<svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect
    class:error={color === "error"}
    class:dark={color === "dark"}
    width="16"
    height="16"
    rx="8"
  />
  <path
    d="M8.73343 9.88346H7.33343L7.1001 3.4668H8.96676L8.73343 9.88346ZM8.96676 12.5668H7.1001V10.9335H8.96676V12.5668Z"
    fill="white"
  />
</svg>

<style>
  rect {
    fill: currentColor;
  }

  .dark {
    fill: var(--rekki-dark);
  }
  .error {
    fill: var(--rekki-error);
  }
</style>
